import { render } from "./Plans-page.vue?vue&type=template&id=46662343&scoped=true"
import script from "./Plans-page.vue?vue&type=script&lang=js"
export * from "./Plans-page.vue?vue&type=script&lang=js"

import "./Plans-page.vue?vue&type=style&index=0&id=46662343&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46662343"]])

export default __exports__